
import {
    ADD_PRODUCT_TO_CART_MUTATION,
    ADD_PRODUCTS_TO_CART_MUTATION,
} from '@marketplace/graphql/cart.js'
import { getFirstUserError } from '@marketplace/helpers/data.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import Cookies from 'js-cookie'

export default {
    name: 'ButtonAddToCart',

    props: {
        price: {
            type: Number,
            required: true,
        },
        currentQuantity: {
            type: Number,
            required: true,
        },
        storefrontId: {
            type: String,
            required: true,
        },
        isFavorite: {
            type: Boolean,
            default: false,
        },
        listingId: {
            type: String,
            default: null,
        },
        variantId: {
            type: String,
            default: null,
        },
        variantIds: {
            type: Object,
            default: null,
        },
        componentSource: {
            type: String,
            default: '',
        },
        doesShipToLocale: {
            type: Boolean,
            required: false,
            default: false,
        },
        isOutOfStock: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            isLoading: false,
            isSaved: false,
            userErrorMessage: '',
        }
    },
    computed: {
        canSubmitCart() {
            if (this.variantId && this.variantId !== '') {
                return (
                    this.price !== null &&
                    this.price >= 0 &&
                    this.currentQuantity > 0
                )
            }

            if (this.variantIds && Object.keys(this.variantIds).length > 0) {
                return Object.values(this.variantIds).some(
                    (item) => item.quantity > 0
                )
            }

            return false
        },
        products() {
            const productArray = []
            if (this.variantIds) {
                Object.entries(this.variantIds).forEach(([key, value]) => {
                    const item = {
                        listingVariantId: key,
                        storefrontId: this.storefrontId,
                        quantity: value.quantity,
                    }
                    productArray.push(item)
                })
            }
            return productArray
        },
        trackingCategory() {
            return this.$helpers.getSegmentCategoryNamebyRoute(
                this.$page.currentRouteName
            )
        },
        discoveryPath() {
            const path = Cookies.get('discovery_path') || 'direct'
            return path
        },
    },

    watch: {
        listingId(newListingId, oldListingId) {
            if (newListingId !== oldListingId) {
                this.isSaved = false
            }
        },
    },

    methods: {
        triggerSubmit(e) {
            e.target.blur()
            this.isLoading = true
            if (this.variantId && this.variantId !== '') {
                this.submitToCart()
            } else if (
                this.variantIds &&
                Object.keys(this.variantIds).length > 0
            ) {
                this.submitMultipleToCart()
            } else {
                this.isLoading = false
            }
        },
        submitToCart() {
            this.isSaved = false

            this.$apollo
                .mutate({
                    mutation: ADD_PRODUCT_TO_CART_MUTATION,

                    variables: {
                        product: {
                            listingVariantId: this.variantId,
                            quantity: this.currentQuantity,
                            storefrontId: this.storefrontId,
                            path: this.$route.path,
                            discoveryPath: this.discoveryPath,
                        },
                    },
                })
                .then((res) => {
                    if (
                        !res.data.cartProductCreate.userErrors ||
                        res.data.cartProductCreate.userErrors.length === 0
                    ) {
                        this.onSuccess()
                        this.isSaved = true
                    } else {
                        this.userErrorMessage = getFirstUserError(
                            res.data.cartProductCreate
                        )
                        this.$emit(
                            'cartUserErrorMessage',
                            this.userErrorMessage
                        )
                    }
                })
                .catch((error) => {
                    this.$sentry.captureException(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        submitMultipleToCart() {
            this.$apollo
                .mutate({
                    mutation: ADD_PRODUCTS_TO_CART_MUTATION,
                    variables: {
                        products: this.products,
                    },
                })
                .then((res) => {
                    if (
                        !res.data.cartProductsCreate.userErrors ||
                        res.data.cartProductsCreate.userErrors.length === 0
                    ) {
                        this.onSuccess()
                    } else {
                        this.userErrorMessage = getFirstUserError(
                            res.data.cartProductsCreate
                        )

                        this.$emit(
                            'cartUserErrorMessage',
                            this.userErrorMessage
                        )
                    }
                })
                .catch((error) => {
                    this.$sentry.captureException(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        onSuccess() {
            this.$emit('addToCartSuccessCallback', true)

            EventBus.$emit('modal-quickbuy-tracking', {
                category: this.trackingCategory,
                name: this.componentSource,
                listingId: this.listingId,
            })

            let totalQuantity = this.currentQuantity
            if (this.variantIds && Object.keys(this.variantIds).length > 0) {
                totalQuantity = Object.values(this.variantIds).reduce(
                    (sum, variant) => {
                        return sum + (variant.quantity || 0)
                    },
                    0
                )
            }

            setTimeout(() => {
                this.$notify({
                    title: this.$tc('toast.cart.added', totalQuantity),
                    data: {
                        cta: {
                            to: this.localePath('/cart'),
                            text: this.$t('cart.labels.view_cart'),
                            trackingType: 'add-to-cart',
                        },
                    },
                    duration: 4000,
                })

                EventBus.$emit('show-header-cart')
            }, 200)
        },
        setConfirmed() {
            this.isSaved = false
            this.$emit('confirmedAnimationDone')
        },
    },
}
